<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>入库列表</b></p>

            <div style="display:inline-block">
                <el-radio-group v-model="statusSearch" @input="searchByStatus">
                    <el-radio-button label="0">待检验</el-radio-button>
                    <el-radio-button label="1">待接收</el-radio-button>
                    <el-radio-button label="2">待审批</el-radio-button>
                    <el-radio-button label="3">已入库</el-radio-button>
                    <el-radio-button label="4">已退回</el-radio-button>
                    <el-radio-button label="-1">全部</el-radio-button>
                </el-radio-group>
            </div>

            <div style="display:inline-block;width: 300px;">
                <el-input placeholder="请输入产品" v-model="queryValue" class="input-with-select">

                    <el-button slot="append" icon="el-icon-search" @click="searchIn"></el-button>
                </el-input>
            </div>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="backClick()">退回</el-button>
            </p>
            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="operateClick(2)">审批</el-button>
                <span>-</span>
            </p>
            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="operateClick(1)">接收</el-button>
                <span>-</span>
            </p>
            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="testClick()">检验</el-button>
                <span>-</span>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="openDrawer">新增入库</el-button>
                <span>-</span>
            </p>

        </div>

        <div style="margin-bottom: 20px;">
            <el-date-picker v-model="timeFrameValue" type="daterange" align="right" unlink-panels range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="monthChange">
            </el-date-picker>

            <!-- <p style="display:inline;float: right;line-height: 40px;margin:0;">
                <el-button round @click="exportExcel">导出</el-button>
            </p> -->
        </div>

        <el-table :data="inStockList" style="width: 100%" @select="selectClick" @row-click="rowClick" ref="inStockTable"
            highlight-current-row>
            <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
            </el-table-column>

            <el-table-column prop="inStockCode" label="入库编号" min-width="15%">
            </el-table-column>
            <el-table-column prop="productName" label="产品名称" min-width="33%">
            </el-table-column>
            <el-table-column prop="status" label="状态" min-width="10%">
            </el-table-column>

            <el-table-column prop="createdTime" label="申请日期" min-width="12%">
            </el-table-column>
            <el-table-column prop="applicant" label="申请人" min-width="10%">
            </el-table-column>

            <el-table-column prop="remark" label="备注" min-width="20%">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="success" round size="small">
                        查看
                    </el-button>
                    <el-button @click="deleteClick(scope.row)" type="danger" round size="small"
                        v-if="scope.row.status == '已入库' ? false : true">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount"
                layout="total, sizes,prev, pager, next" :total="total" @current-change="pageClick"
                :page-sizes="[10, 15, 20, 25]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

        <el-drawer title="入库详情" :visible.sync="drawerVisible" size="60%" style="text-align: left;">

            <el-row>
                <el-col :span="12">
                    <p style="display:inline-block;width:80px;text-align: center;">申请日期</p>
                    <el-date-picker v-model="form.createdTime" type="date" placeholder="选择日期"
                        :disabled="productItemDisabled">
                    </el-date-picker>
                </el-col>

                <el-col :span="12">
                    <p style="display:inline-block;width:80px;text-align: center;">备注</p>
                    <el-input placeholder="请输入" v-model="form.remark" clearable style="display:inline-block;width:400px"
                        :disabled="productItemDisabled"></el-input>

                </el-col>
            </el-row>

            <el-row>
                <el-col :span="8">
                    <p style="display:inline-block;width:80px;text-align: center;" v-if="saveBtnShow">大类</p>
                    <el-select v-model="form.bigType" placeholder="请选择" style="width:220px" @change="bigChange"
                        v-if="saveBtnShow">
                        <el-option v-for="item in form.bigTypeList" :key="item.value" :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>

                </el-col>
                <el-col :span="8">
                    <p style="display:inline-block;width:80px;text-align: center;" v-if="saveBtnShow">类别</p>
                    <el-select v-model="form.productType" placeholder="请选择" style="width:220px" @change="typeChange"
                        v-if="saveBtnShow">
                        <el-option v-for="item in form.prodTypeList" :key="item.value" :label="item.productTypeName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>

                <el-col :span="8">
                    <p style="display:inline-block;width:80px;text-align: center;" v-if="saveBtnShow">添加产品</p>
                    <el-select v-model="form.productName" filterable remote reserve-keyword placeholder="请输入关键字"
                        :remote-method="searchProduct" :loading="loading" v-if="saveBtnShow">
                        <el-option v-for="item in form.productList" :key="item.value" :label="item.productName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-button type="primary" @click="addProduct" v-if="saveBtnShow">添加</el-button>
                </el-col>
            </el-row>


            <div style="padding:10px;margin-bottom: 20px;">
                <el-table :data="inStockProductList" show-summary>
                    <el-table-column prop="productCode" label="产品编号" min-width="20%">
                    </el-table-column>
                    <el-table-column prop="productName" label="产品名称" min-width="30%">
                    </el-table-column>
                    <el-table-column prop="productWeight" label="产品重量" min-width="10%">
                    </el-table-column>

                    <el-table-column prop="quantity" label="数量" min-width="10%">
                        <template inline-template slot-scope="scope">
                            <el-input v-model="scope.row.quantity" size="mini" :disabled="productItemDisabled">
                            </el-input>
                        </template>
                    </el-table-column>

                    <el-table-column prop="unit" label="单位" min-width="10%">
                    </el-table-column>

                    <el-table-column prop="productRemark" label="备注" min-width="25%">
                        <template inline-template slot-scope="scope">
                            <el-input v-model="scope.row.productRemark" size="mini"
                                :disabled="productItemDisabled"></el-input>
                        </template>
                    </el-table-column>

                    <el-table-column prop="ckStatusStr" label="检验" min-width="10%">
                    </el-table-column>

                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">

                            <el-button @click="removeProduct(scope.row)" type="danger" round size="small" :disabled="delBtnDisable">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div>
                <div style="margin-left: 40%;">
                    <el-button type="primary" round @click="addInStock" v-if="saveBtnShow">保存</el-button>

                    <!-- <el-button type="primary" round @click="editClick" v-if="!saveBtnShow && editBtnShow">编辑</el-button> -->
                </div>

            </div>

            <div>
                <p style="margin-left:20px;font-weight:bold">流转日志</p>
                <div style="padding:10px;">
                    <el-table :data="logList">
                        <el-table-column prop="createdTime" label="操作时间" min-width="25%">
                        </el-table-column>
                        <el-table-column prop="operationType" label="操作类型" min-width="25%">
                        </el-table-column>
                        <el-table-column prop="operator" label="操作人" min-width="25%">
                        </el-table-column>
                        <el-table-column prop="remark" label="操作说明" min-width="25%">
                        </el-table-column>
                    </el-table>
                </div>

            </div>

        </el-drawer>

        <el-dialog title="退回" :visible.sync="dialogVisible" v-dialogDrag v-if="dialogVisible">
            <p style="display:inline-block;width:80px;text-align: center;">退回原因：</p>
            <el-input placeholder="请输入" v-model="backRemark" clearable
                style="display:inline-block;width:400px"></el-input>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmBack">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="检验详情" :visible.sync="testDlgVisible" width="45%" v-dialogDrag v-if="testDlgVisible">

            <div
                style="background-color: #f5f7fa;color:green;font-size: 14px;text-align:left;padding: 15px 0 15px 10px;">
                入库产品
            </div>

            <div v-for="item in inStockProductList" :key="item.id" style="display:flex">
                <p style="text-align: left;width:70%">{{ item.productName }}</p>

                <div style="display:inline-block;line-height: 40px;margin: 5px 0;">
                    <el-radio-group v-model="item.checkStatus">
                        <el-radio :label="1">合格</el-radio>
                        <el-radio :label="2">不合格</el-radio>
                    </el-radio-group>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="testDlgVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveTestClick('ruleForm')">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "InStock",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            userId: this.getUserId(),

            inStockList: [],

            drawerVisible: false,
            dialogVisible: false,
            testDlgVisible: false,

            statusSearch: 0,
            form: {
                id: '',
                inStockCode: '自动生成',

                bigType: '',
                bigTypeList: [{
                    id: 0,
                    name: '零件'
                }, {
                    id: 1,
                    name: '半成品'
                }, {
                    id: 2,
                    name: '成品'
                }],
                productType: '',
                prodTypeList: [],
                productList: [],
                productId: '',
                productName: '',

                createdTime: new Date(),
                status: 0,
                remark: '',
            },
            loading: false,
            formLabelWidth: '120px',

            queryValue: '',

            inStockProductList: [],
            productItemDisabled: false,
            delBtnDisable: false,
            logList: [],

            saveBtnShow: true,
            editBtnShow: false,

            pageIndex: 0,
            pageNum: 10,
            total: 0,
            pageCount: 0,

            backRemark: '',

            timeFrameValue: '',
            startTime: null,
            endTime: null,

            rules: {
                customer: [
                    { required: true, message: '请输入客户', trigger: 'blur' },
                    { required: true, message: '请输入客户', trigger: 'change' }
                ],
                salesman: [
                    { required: true, message: '请输入业务员', trigger: 'blur' },
                    { required: true, message: '请输入业务员', trigger: 'change' }
                ],
                productName: [
                    { required: true, message: '请输入产品名称', trigger: 'blur' },
                    { required: true, message: '请输入产品名称', trigger: 'change' }
                ],
                createdTime: [
                    { required: true, message: '请选择下单日期', trigger: 'blur' },
                    { required: true, message: '请选择下单日期', trigger: 'change' }
                ]
            }
        }
    },
    methods: {
        typeChange() {

            this.getAllBaseProduct(null)

            this.form.productName = ''
        },
        bigChange() {
            this.getTypeByBigType()

            this.form.productType = ''
            this.form.productName = ''
        },
        getTypeByBigType() {
            this.$axios({
                method: "post",
                url: "/shiro/base/product/type/getAll",
                data: {
                    bigType: this.form.bigType,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.form.prodTypeList = data.data
            })
        },
        monthChange() {
            this.startTime = this.timeFrameValue[0]
            this.endTime = this.timeFrameValue[1]

            this.getAll(this.statusSearch)
        },
        searchIn(query) {
            this.inStockList = []

            if (this.queryValue !== '') {
                this.loading = true
                setTimeout(() => {
                    this.loading = false

                    this.getAll(this.statusSearch)
                }, 200)
            } else {
                this.$message({
                    type: 'info',
                    message: '请输入搜索条件'
                })
            }
        },
        addProduct() {

            // console.log('add')
            // console.log(this.form.productName)
            const index = this.form.productList.findIndex(obj => obj.id == this.form.productName)

            // console.log(this.form.productList[index])
            this.inStockProductList.push(this.form.productList[index])
        },
        removeProduct(row) {

            // console.log('remove')
            // console.log(row)

            const index = this.inStockProductList.findIndex(obj => obj.id == row.id)

            this.inStockProductList.splice(index, 1)
        },
        getAllBaseProduct(val) {
            this.$axios({
                method: "post",
                url: "/shiro/base/product/getAll",
                data: {
                    queryParam: val,
                    status: 1,
                    bigType: -1,
                    productType: this.form.productType,
                    pageIndex: -1,
                    pageNum: -1,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.form.productList = data.data

            })
        },
        searchProduct(val) {
            if (val !== '') {

                this.loading = true;

                setTimeout(() => {
                    this.loading = false;
                    this.getAllBaseProduct(val)
                }, 200);

            } else {
                this.form.productList = []
            }
        },
        selectClick(selection, row) {

            this.$refs.inStockTable.clearSelection()
            this.$refs.inStockTable.toggleRowSelection(row)
            this.form.id = row.id
            this.form.status = row.status
        },
        rowClick(row) {
            //console.log(row)
            this.$refs.inStockTable.clearSelection()
            this.$refs.inStockTable.toggleRowSelection(row)
            this.form.id = row.id
            this.form.status = row.status
        },
        getInStockProduct(row) {

            this.$axios({
                method: "post",
                url: "/shiro/in/stock/getOne",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.inStockProductList = data.data.inStockProductVOList
                for (let i in this.inStockProductList) {
                    this.inStockProductList[i].productRemark = this.inStockProductList[i].remark

                    if (this.inStockProductList[i].checkStatus == 0) {
                        this.inStockProductList[i].ckStatusStr = '未检'
                    } else if (this.inStockProductList[i].checkStatus == 1) {
                        this.inStockProductList[i].ckStatusStr = '合格'
                    } else if (this.inStockProductList[i].checkStatus == 2) {
                        this.inStockProductList[i].ckStatusStr = ' 不合格'
                    }
                }

                this.logList = data.data.inOutLogsList
                for (let i in this.logList) {
                    this.logList[i].createdTime = this.$moment(this.logList[i].createdTime).format("YYYY-MM-DD HH:mm:ss")

                    if (this.logList[i].operationType == 0) {
                        this.logList[i].operationType = '申请'
                    } else if (this.logList[i].operationType == 1) {
                        this.logList[i].operationType = '检验'
                    } else if (this.logList[i].operationType == 2) {
                        this.logList[i].operationType = ' 接收'
                    } else if (this.logList[i].operationType == 3) {
                        this.logList[i].operationType = ' 审批'
                    } else {
                        this.logList[i].operationType = '退回'
                    }
                }


            })
        },
        handleClick(row) {
            // console.log(row);
            this.form.id = row.id

            this.form.inStockCode = row.inStockCode

            this.form.createdTime = row.createdTime

            this.form.status = null
            this.form.remark = row.remark

            this.form.productName = ''

            this.drawerVisible = true
            this.productItemDisabled = true
            this.delBtnDisable = true

            this.saveBtnShow = false
            this.editBtnShow = false
            if (row.status == '待接收') {
                this.editBtnShow = true
            }

            this.getInStockProduct(row)
            this.getAllBaseProduct('')
        },
        openDrawer() {

            this.form.id = ''
            this.form.inStockCode = '自动生成'

            this.form.applicant = ''
            this.form.productName = ''

            this.form.createdTime = new Date()

            this.form.status = 0
            this.form.remark = ''

            this.inStockProductList = []
            this.logList = []

            this.productItemDisabled = false
            this.saveBtnShow = true

            this.drawerVisible = true
            this.getAllBaseProduct('')
        },
        operateClick(val) {

            if (this.form.id == '') {
                this.$message({
                    type: 'info',
                    message: '请选择入库单'
                })
                return
            }

            this.$confirm('确定执行此操作吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                if (val == 1) {
                    this.receiveClick()
                } else {
                    this.checkClick()
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                })
            })
        },
        receiveClick() {

            this.$axios({
                method: "post",
                url: "/shiro/in/stock/receive",
                data: {
                    id: this.form.id,
                    status: 2,
                    applicant: this.userId,
                    remark: '',
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.drawerVisible = false
                this.getAll(this.statusSearch)
            })
        },
        checkClick() {

            this.$axios({
                method: "post",
                url: "/shiro/in/stock/check",
                data: {
                    id: this.form.id,
                    status: 3,
                    applicant: this.userId,
                    remark: '',
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.drawerVisible = false
                this.getAll(this.statusSearch)
            })
        },
        testClick() {

            if (this.form.id == '') {
                this.$message({
                    type: 'info',
                    message: '请选择入库单'
                })
                return
            }

            if (this.form.status != '待检验') {
                this.$message({
                    type: 'info',
                    message: '当前状态不允许操作'
                })
                return
            }

            var row = { id: this.form.id }
            this.getInStockProduct(row)

            this.testDlgVisible = true
        },
        saveTestClick() {

            this.$axios({
                method: "post",
                url: "/shiro/in/stock/test",
                data: {
                    id: this.form.id,
                    status: 1,
                    applicant: this.userId,
                    inStockProductList: this.inStockProductList,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.testDlgVisible = false

                this.getAll(this.statusSearch)
            })
        },
        backClick() {

            if (this.form.id == '') {
                this.$message({
                    type: 'info',
                    message: '请选择入库单'
                })
                return
            }

            if (this.form.status == '已入库' || this.form.status == '已退回') {
                this.$message({
                    type: 'info',
                    message: '当前状态不允许操作'
                })
                return
            }

            this.dialogVisible = true
        },
        confirmBack() {

            this.$axios({
                method: "post",
                url: "/shiro/in/stock/goBack",
                data: {
                    id: this.form.id,
                    status: 4,
                    applicant: this.userId,
                    remark: this.backRemark,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.dialogVisible = false
                this.getAll(this.statusSearch)
            })
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removeInStock(row)
                // this.$message({
                //     type: 'success',
                //     message: '删除成功!'
                // });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        addInStock() {
            const ispList = []

            for (let i in this.inStockProductList) {

                ispList.push({
                    productId: this.inStockProductList[i].id,
                    quantity: this.inStockProductList[i].quantity,
                    remark: this.inStockProductList[i].productRemark
                })
            }

            this.$axios({
                method: "post",
                url: "/shiro/in/stock/add",
                data: {
                    id: this.form.id,
                    inStockCode: this.form.inStockCode,

                    applicant: this.userId,

                    remark: this.form.remark,
                    inStockProductList: ispList,

                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.drawerVisible = false
                this.getAll(this.statusSearch)
            })

        },
        editClick() {

            this.productItemDisabled = false
            this.delBtnDisable = false

            this.saveBtnShow = true
        },
        printInStock(fang) {
            // console.log('fang')
            // console.log(fang)
            var content = document.getElementById("warehousing-list").innerHTML
            // console.log(content)

            var sprnstr = "<!--startprint" + fang + "-->"
            var eprnstr = "<!--endprint" + fang + "-->"

            var iframe = document.createElement("IFRAME")
            // console.log('iframe')
            // console.log(iframe)
            var doc = null;
            iframe.setAttribute('style', 'position:absolute;width:0;height:0;left:-500px;top:-500px;')

            document.body.appendChild(iframe)
            doc = iframe.contentWindow.document
            // console.log('doc')
            // console.log(doc)
            doc.write(content)
            doc.close()
            iframe.contentWindow.focus()

            iframe.contentWindow.addEventListener('load', function () {
                console.log('addEventListener')
                iframe.contentWindow.print()
                document.body.removeChild(iframe)
            })

        },
        searchByStatus(val) {

            this.getAll(val)
        },
        removeInStock(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/in/stock/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                this.$message({
                    type: 'success',
                    message: data.msg
                })

                this.getAll(this.statusSearch)
            })
        },
        getAll(val) {
            // const formData = new FormData()

            // formData.append('status', val)

            // formData.append('companyId', this.companyId)
            // formData.append('pageIndex', -1)
            // formData.append('pageNum', -1)

            this.$axios({
                method: "post",
                url: "/shiro/in/stock/getAll",
                data: {
                    status: val,
                    queryParam: this.queryValue,
                    startTime: this.startTime,
                    endTime: this.endTime,
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {
                this.form.id = ''
                this.total = 0

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.inStockList = data.data
                if (this.inStockList.length > 0) {
                    this.total = this.inStockList[0].total
                }
                for (let i in this.inStockList) {
                    this.inStockList[i].createdTime = this.$moment(this.inStockList[i].createdTime).format("YYYY-MM-DD")

                    if (this.inStockList[i].status == 0) {
                        this.inStockList[i].status = '待检验'
                    } else if (this.inStockList[i].status == 1) {
                        this.inStockList[i].status = '待接收'
                    } else if (this.inStockList[i].status == 2) {
                        this.inStockList[i].status = '待审批'
                    } else if (this.inStockList[i].status == 3) {
                        this.inStockList[i].status = '已入库'
                    } else {
                        this.inStockList[i].status = '已退回'
                    }
                }
            })
        },
        pageClick(currentPage) {
            this.inStockList = []

            this.pageIndex = (currentPage - 1) * this.pageNum
            this.getAll(this.statusSearch)
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAll(this.statusSearch)
        },
    },
    mounted() {
        this.getAll(this.statusSearch)
    },
    updated() {

    }
}
</script>

<style>
#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-pagination__total {
    color: green;
}
</style>